import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, LinkIcon, ShareIcon, SidebarIcon, SwitchesIcon, } from '@streamr/tv-ui';
import { useRef } from 'react';
import styled from 'styled-components';
import { Anchor } from '../Anchor';
export function WorkspaceControls(props) {
    const { linkActive = false, onLinkClick, knobsActive = false, onKnobsClick, sidebarActive = false, onSidebarClick, shareActive = false, onShareClick, } = props;
    const linkButtonAnchorRef = useRef(null);
    const knobsButtonAnchorRef = useRef(null);
    const sidebarButtonAnchorRef = useRef(null);
    const shareButtonAnchorRef = useRef(null);
    return (_jsxs(WorkspaceControlsRoot, { children: [onLinkClick && (_jsx(Anchor, { ref: linkButtonAnchorRef, children: _jsx(Button, { type: "button", active: linkActive, onClick: () => {
                        onLinkClick?.(linkButtonAnchorRef);
                    }, children: _jsx(LinkIcon, {}) }) })), onShareClick && (_jsx(Anchor, { ref: shareButtonAnchorRef, children: _jsx(Button, { type: "button", active: shareActive, onClick: () => {
                        onShareClick?.(shareButtonAnchorRef);
                    }, children: _jsx(ShareIcon, {}) }) })), onKnobsClick && (_jsx(Anchor, { ref: knobsButtonAnchorRef, children: _jsx(Button, { type: "button", active: knobsActive, onClick: () => {
                        onKnobsClick?.(knobsButtonAnchorRef);
                    }, children: _jsx(SwitchesIcon, {}) }) })), onSidebarClick && (_jsx(Anchor, { ref: sidebarButtonAnchorRef, className: "temp_sidebarButtonAnchor", children: _jsx(Button, { type: "button", active: sidebarActive, onClick: () => {
                        onSidebarClick?.(sidebarButtonAnchorRef);
                    }, children: _jsx(SidebarIcon, {}) }) }))] }));
}
const WorkspaceControlsRoot = styled.div `
    --Button_BorderRadius: 0.75rem;
    --Button_HoverBackground: rgba(255, 255, 255, 0.1);
    --Button_ActiveBackground: rgba(255, 255, 255, 0.1);
    background: #8080804D;
    mix-blend-mode: luminosity;
    backdrop-filter: blur(20px);
    border: none;
    box-shadow:
        1px 1.5px 4px 0px #0000001a inset,
        1px 1.5px 4px 0px #00000014 inset,
        0px -0.5px 1px 0px #ffffff40 inset,
        0px -0.5px 1px 0px #ffffff4d inset;
    color: var(--tv-ui-color-3);
    border-radius: 1.125rem;
    align-items: center;
    display: flex;
    gap: 0.375rem;
    padding: 0.375rem;

    button {
        height: 2rem;
        width: 2rem;
    }

    /* For now make the sidebar (chat) only visible on desktop. */

    .temp_sidebarButtonAnchor {
        display: none;
    }

    @media (min-width: 60rem) {
        .temp_sidebarButtonAnchor {
            display: flex;
        }
    }
`;
